import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ServicesPage from '@/pages/services/page';
import AboutPage from '@/pages/about/page';
import FAQPage from '@/pages/faq/page';
import ContactPage from '@/pages/contact/page';
import EventsPage from '@/pages/events/page';
import HardDriveDestructionPage from '@/pages/hard-drive-destruction/page';
import TVRecyclingPage from '@/pages/tv-recycling/page';
import ComputerRecyclingPage from '@/pages/computer-recycling/page';
import BatteryRecyclingPage from '@/pages/battery-recycling/page';
import EvChargingRecyclingPage from '@/pages/ev-charging-recycling/page';
import LocationsPage from '@/pages/locations/page';
import West3rdStreetPage from '@/pages/locations/West3rdStreetPage';
import SlausonAvePage from '@/pages/locations/SlausonAvePage';
import AdminPage from '@/pages/admin/page';
import ReviewsPage from '@/pages/reviews/page';
import PickupRequestPage from '@/pages/pickup-request/page';
import DropOffFormPage from '@/pages/dropoff-form/page';
import ServiceAreasPage from '@/pages/service-areas/page';
import BurbankPage from '@/pages/city/BurbankPage';
import GlendalePage from '@/pages/city/GlendalePage';
import PasadenaPage from '@/pages/city/PasadenaPage';
import LongBeachPage from '@/pages/city/LongBeachPage';
import SantaMonicaPage from '@/pages/city/SantaMonicaPage';
import CulverCityPage from '@/pages/city/CulverCityPage';
import TorrancePage from '@/pages/city/TorrancePage';
import InglewoodPage from '@/pages/city/InglewoodPage';
import DTLAPage from '@/pages/city/DTLAPage';
import RedondoBeachPage from '@/pages/city/RedondoBeachPage';
import VanNuysPage from '@/pages/city/VanNuysPage';
import HawthornePage from '@/pages/city/HawthornePage';
import SitemapPage from '@/pages/sitemap/page';
import PrivacyPolicyPage from '@/pages/privacy-policy/page';
import TermsOfServicePage from '@/pages/terms-of-service/page';
import ReserveDatePage from '@/pages/reserve-date/page';
import NotFound from '@/pages/NotFound';
import BlogPage from '@/pages/blog/page';
import ArticlePage from '@/pages/blog/ArticlePage';
import EwasteGuidePage from '@/pages/e-waste-guide/page';
import SustainabilityReportPage from '@/pages/sustainability-report/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/e-waste-guide', element: <EwasteGuidePage /> },
  { path: '/sustainability-report', element: <SustainabilityReportPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:slug', element: <ArticlePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/tv-recycling', element: <TVRecyclingPage /> },
  { path: '/computer-recycling', element: <ComputerRecyclingPage /> },
  { path: '/battery-recycling', element: <BatteryRecyclingPage /> },
  { path: '/ev-charging-recycling', element: <EvChargingRecyclingPage /> },
  { path: '/locations', element: <LocationsPage /> },
  { path: '/locations/west-3rd-street', element: <West3rdStreetPage /> },
  { path: '/locations/slauson-ave', element: <SlausonAvePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/events', element: <EventsPage /> },
  { path: '/hard-drive-destruction', element: <HardDriveDestructionPage /> },
  { path: '/pickup-request', element: <PickupRequestPage /> },
  { path: '/dropoff-form', element: <DropOffFormPage /> },
  { path: '/service-areas', element: <ServiceAreasPage /> },
  { path: '/electronics-recycling-burbank', element: <BurbankPage /> },
  { path: '/electronics-recycling-glendale', element: <GlendalePage /> },
  { path: '/electronics-recycling-pasadena', element: <PasadenaPage /> },
  { path: '/electronics-recycling-long-beach', element: <LongBeachPage /> },
  { path: '/electronics-recycling-santa-monica', element: <SantaMonicaPage /> },
  { path: '/electronics-recycling-culver-city', element: <CulverCityPage /> },
  { path: '/electronics-recycling-torrance', element: <TorrancePage /> },
  { path: '/electronics-recycling-inglewood', element: <InglewoodPage /> },
  { path: '/electronics-recycling-downtown-los-angeles', element: <DTLAPage /> },
  { path: '/electronics-recycling-redondo-beach', element: <RedondoBeachPage /> },
  { path: '/electronics-recycling-van-nuys', element: <VanNuysPage /> },
  { path: '/electronics-recycling-hawthorne', element: <HawthornePage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/sitemap', element: <SitemapPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/terms-of-service', element: <TermsOfServicePage /> },
  { path: '/reserve-date', element: <ReserveDatePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;